const request = {}

request.createRequest = function (params) {
  return { arrivalDate: params.date }
}
export default { request }
